export default __webpack_public_path__ + "static/media/cart-small.c3a04f9f.svg";